/**
 * Instagram-ready caption for a previewed Madras Checks artwork.
 * Uses the artwork's own seed, palette label, pattern type, and /g/{id} permalink.
 */

const PATTERN_TYPE_LABELS: Record<string, string> = {
  classic: 'Classic',
  bleed: 'Bleed',
  modern: 'Modern',
};

/** Canonical display label for a generator patternType value. */
export function formatPatternTypeLabel(patternType: unknown): string {
  const key = String(patternType || 'classic').toLowerCase();
  return PATTERN_TYPE_LABELS[key] || PATTERN_TYPE_LABELS.classic;
}

export function buildArtworkPostText(opts: {
  seed: string;
  paletteName: string;
  permalink: string;
  /** Generator patternType: classic | bleed | modern */
  patternType?: string | null;
}): string {
  const seed = String(opts.seed || '');
  const paletteName = String(opts.paletteName || 'Custom');
  const permalink = String(opts.permalink || '');
  const pattern = formatPatternTypeLabel(opts.patternType);

  return [
    'Madras Checks by @valipokkann',
    '',
    `Seed: ${seed}`,
    `Palette: ${paletteName}`,
    `Pattern: ${pattern}`,
    '',
    permalink,
    '',
    '#madraschecks #valipokkann #generativeart #textileart #digitalart',
  ].join('\n');
}
